import { Reducer } from "redux";

import { CareTypeResponse } from "../models/Api/Master";
import { CareTypeActionDispatchTypes } from "../constants/Master";
import { CareTypeDispatchTypes } from "../models/DispatchTypes/Master";
import { setLocalStorageData } from "../utils";

const initialState: CareTypeResponse = {
  loading: false,
  response: [],
};

const CareTypeReducer: Reducer<CareTypeResponse, CareTypeDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CareTypeActionDispatchTypes.CARE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS: {
      setLocalStorageData(
        CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case CareTypeActionDispatchTypes.CARE_TYPE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default CareTypeReducer;
